const INTERVAL_META_NAME = "turbo-refresh-interval"
const RELOAD_HTML = '<turbo-stream action="refresh"></turbo-stream>'
let intervalId = null

function getRefreshInterval() {
  const meta = document.querySelector(`meta[name="${INTERVAL_META_NAME}"]`)
  if (!meta) return null
  const value = parseInt(meta.content, 10)
  return isNaN(value) || value <= 0 ? null : value
}

function injectReloadTrigger() {
  document.body.insertAdjacentHTML("beforeend", RELOAD_HTML)
}

function clearRefreshInterval() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}

function setupTurboReloader() {
  clearRefreshInterval()
  const interval = getRefreshInterval()
  if (!interval) return
  intervalId = setInterval(injectReloadTrigger, interval * 1000)
}

document.addEventListener("turbo:load", setupTurboReloader)
